export default "__VITE_ASSET__6e5bb33b__"